
var _artistResidenceCurrentElement = null;
var _artistResidenceMovementRunning = false;
var _artistResidenceElementsWidth = 0;
var _artistResidenceTransformCompleteCount = 3;
var _artistResidenceMobileVersionEnabled = true;

(function ($) { 
    
    Drupal.behaviors.artistResidency = {
        attach: function (context) {
            
            //Drupal.behaviors.functions.consolog("drupal init artistResidency");

            $(".artistResidenceHeader", context).each(function (index){    

                if($(this).hasClass("mobile-enabled")){
                    _artistResidenceMobileVersionEnabled = true;
                }
                else{
                    _artistResidenceMobileVersionEnabled = false;
                }
                
                $(".artistResidenceHeaderElements").empty();

                //add title text to detail view
                var titleText = $(".artistResidenceHeaderTitle").find("h1").text();
                $(".artistResidenceHeaderDetail").find(".artistGalleryTitle").html(titleText);
                
                var data = function( data ) {
                    var items = data;
                    // Drupal.behaviors.functions.consolog("load artists done! " + items.length);
                    
                    for(var i=0; i<items.length; i++){
                        var artist = items[i];
                        //Drupal.behaviors.functions.consolog("artist:" + artist.label1);
                        let counter = i + 1;
                        var $element = $("<div></div>");
                        $element.addClass("artistResidenceHeaderElement");
                        $element.addClass("img" + counter);
                        $element.attr("data-img1", artist.img1);
                        $element.attr("data-img2", artist.img2);
                        $element.attr("data-desc", artist.description);
                        $element.attr("data-number", counter);
                        $element.attr("data-news-url", artist.url);
                        $element.attr("data-news-label", "news");

                        var $imgElement = $("<div></div>");
                        $imgElement.addClass("artistResidenceHeaderElementImage");

                        var $img = $("<img />");
                        $img.attr("alt", artist.label1);
                        if(artist.border){
                            $img.addClass("showBorder");
                        }
                        $imgElement.append($img);
                        $img.attr("src", artist.img1);
                        $img.one("load", function() {
                            $(this).css("opacity", 1);
                        });                        

                        $element.append($imgElement);

                        var $label1 = $("<div class='artistResidenceHeaderElementLabel'>" + artist.label1 + "</div>");
                        var $label2 = $("<div class='artistResidenceHeaderElementLabel'>" + artist.label2 + "</div>");
                        $element.append($label1);
                        $element.append($label2);

                        $(".artistResidenceHeaderElements").append($element);
                    }
                    
                    //calculate full width
                    _artistResidenceElementsWidth = 0;                    
                    $(".artistResidenceHeaderElement").each(function(){
                        //if($(this).attr("data-img1") != "" && $(this).attr("data-img2") != ""){
                        if($(this).attr("data-img1") != ""){
                            var left = $(this).position().left + $(this).width();
							$(this).attr("data-left", $(this).css("left"));
                            if(left > _artistResidenceElementsWidth){
                                _artistResidenceElementsWidth = left;
                            }
                        }                        
                    });                   
                    //Drupal.behaviors.functions.consolog("_artistResidenceElementsWidth:" + _artistResidenceElementsWidth);

                    //_artistResidenceElementsWidth = 3686; 
                    
                    if($(window).width() <= 767 && _artistResidenceMobileVersionEnabled){
                        $(".artistResidenceHeaderElements").css("width", _artistResidenceElementsWidth);
                    }

                    //handle element hover
                    $(".artistResidenceHeaderElement").hover(
                        function() {
                            //mouse in
                            stopMovement();
                        }, 
                        function() {
                            //mouse out
                            if($(".artistResidenceHeaderElement.active").length == 0){
                                if(_artistResidenceCurrentElement == null){
                                    startMovement();                    
                                }            
                            }                            
                        }
                    );

                    _artistResidenceTransformCompleteCount = 3;

                    //handle element click
                    $(".artistResidenceHeaderElement").click(function(){
                    
                        if(_artistResidenceCurrentElement){
                            return;
                        }

                        if(_artistResidenceTransformCompleteCount < 3){
                            return;
                        }

                        _artistResidenceCurrentElement = $(this);

                        $(".artistResidenceHeaderDetail").removeClass("flipping");
                        $(".artistResidenceHeaderDetail").addClass("flipping");                        

                        stopMovement();

                        //var st = Math.round($(this).position().top-$(window).height()/2);
                        $('html, body').animate({scrollTop:0},500);

                        $(".preloader").show();                        

                        $(".artistResidenceHeaderElement").removeClass("loading");
                        $(this).addClass("loading");
                    
                        $(".artistResidenceHeaderFlipImage").children(".front").attr("src", $(this).attr("data-img1"));
                        $(".artistResidenceHeaderFlipImage").children(".back").attr("src", $(this).attr("data-img2"));                        

                        //set flip element on clicked elment position and size
                        var imgContainer = $(this).children(".artistResidenceHeaderElementImage");
                        var heightOffset = imgContainer.height() - imgContainer.children("img").height();
                        $(".artistResidenceHeaderFlipImage").css("left", $(this).offset().left);
                        $(".artistResidenceHeaderFlipImage").css("top", $(this).offset().top + heightOffset);
                        $(".artistResidenceHeaderFlipImage").css("width", $(this).find("img").width());
                        $(".artistResidenceHeaderFlipImage").css("height", $(this).find("img").height());

                        var $detail = $(".artistResidenceHeaderDetail");

                        //set portrait image
                        $detail.find(".artistGalleryFooterBlockImage").css("background-image", "url(" + $(this).attr("data-img1") + ")");
                        
                        //set portrait label
                        var label1 = $(this).children(".artistResidenceHeaderElementLabel").eq(0).html();
                        var label2 = $(this).children(".artistResidenceHeaderElementLabel").eq(1).html();
                        $detail.find(".artistGalleryFooterBlock").eq(1).html("");

                        if(label1 != ""){
                            $detail.find(".artistGalleryFooterBlock").eq(1).append("<div class='artistGalleryFooterLabel'>" + label1 + "</div>");    
                        }                        
                        if(label2 != ""){
                            $detail.find(".artistGalleryFooterBlock").eq(1).append("<div class='artistGalleryFooterLabel'>" + label2 + "</div>");      
                        }
                        
                        //set portrait news link 
                        $detail.find(".linkButton").remove();
                        if($(this).attr("data-news-url") && $(this).attr("data-news-url") != ""){
                            $detail.find(".artistGalleryFooterBlock").eq(1).append("<div class='linkButton' data-text='" + $(this).attr("data-news-label") + "' data-url='" + $(this).attr("data-news-url") + "' data-position-right='true' data-arrow-color='white' data-arrow-background-color='red' data-text-class='link-primary' data-text-color='black' data-is-small='true'></div>");   
                        }
                        
                        $detail.find(".artistGalleryContentContainer").empty();

                        //clean slider content
                        var $slider = $("<div></div>");
                        $slider.addClass("artistGalleryImageSlider");

                        //create slider page
                        var $page = $("<div></div>");
                        $page.addClass("artistGalleryImageSliderPage");
                        
                        //hide slider navigation elements
                        $(".artistGalleryNavigationLabel").hide();
                        $(".artistGalleryNavigationIcon").hide();

                        //create empty text col
                        var $txt1 = $("<div></div>");
                        $txt1.addClass("artistGalleryText");

                        //create image col
                        var $imgdiv = $("<div></div>");
                        $imgdiv.addClass("artistGalleryImage");
                        $imgdiv.attr("data-image", $(this).attr("data-img2"));

                        //create img
                        var $img = $("<img />");
                        $img.attr("src", $(this).attr("data-img2"));
                        $imgdiv.append($img);                       

                        //create text col
                        var $txt2 = $("<div></div>");
                        $txt2.addClass("artistGalleryText");
                        $txt2.append("<p class='nomargin'>" + $(this).attr("data-desc") + "</p>");

                        //append cols to slider page
                        $page.append($txt1);
                        $page.append($imgdiv);
                        $page.append($txt2);

                        //append page to slider
                        $slider.append($page);

                        //append slider to content
                        $detail.find(".artistGalleryContentContainer").append($slider);

                        //preload images
                        preloadArtistResidencyImages();

                        //create links
                        Drupal.behaviors.linkButtonCreator($(".artistGallery"));

                        //init image slider
                        //Drupal.behaviors.artistGallery.initSlider();
                    });

                    //initial movement start...
                    startMovement();
                };

                var shuffle = function (array) {

                    var currentIndex = array.length;
                    var temporaryValue, randomIndex;

                    // While there remain elements to shuffle...
                    while (0 !== currentIndex) {
                        // Pick a remaining element...
                        randomIndex = Math.floor(Math.random() * currentIndex);
                        currentIndex -= 1;

                        // And swap it with the current element.
                        temporaryValue = array[currentIndex];
                        array[currentIndex] = array[randomIndex];
                        array[randomIndex] = temporaryValue;
                    }

                    return array;
                };

                let artists = $(this).data('artist-data');
                let isSliderRandom = $(this).data('slider-random') || false; 
                
                if (isSliderRandom) {
                    artists = shuffle(artists);
                }
                
                data(artists);            
            });

            
            $(".artistResidenceHeaderDetail", context).each(function (index){                   

                $(this).find(".artistGalleryClosebutton").click(function(){
                    if(_artistResidenceTransformCompleteCount == 3){
                        hideArtistResidenceDetail();      
                    }
                });
                $(this).find(".artistGallery").click(function(event){
                    
                    if(!$(".artistResidenceHeaderDetail").hasClass("preshow")){
                        var target = $(event.target);
                        if(target.is("img") || target.parents(".linkButton").length > 0){
                            //do not close!
                        }
                        else{                        
                            if(_artistResidenceTransformCompleteCount == 3){
                                hideArtistResidenceDetail();      
                            }  
                        }
                    }
                                    
                });
            });            

            function preloadArtistResidencyImages(){

                //Drupal.behaviors.functions.consolog("preloadArtistResidencyImages()");

                var image1 = new Image();
                image1.src = _artistResidenceCurrentElement.attr("data-img1");
                
                image1.onerror = function(){ 

                }                        
                image1.onload = function(){                           

                    var image2 = new Image();
                    image2.src = _artistResidenceCurrentElement.attr("data-img2");
                    
                    image2.onerror = function(){   
                        
                    }                        
                    image2.onload = function(){
                        
                        //Drupal.behaviors.functions.consolog("img 2 loaded!");

                        Drupal.behaviors.artistGallery.artistGalleryInitSlider();

                        $(".artistResidenceHeaderDetail").removeClass("preshow");
                        $(".artistResidenceHeaderDetail").addClass("preshow");
                        Drupal.behaviors.artistGallery.handleSliderResize();

                        setTimeout(function(){
                            //set clicked element active (set opacity to 0)
                            $(".artistResidenceHeaderElement").removeClass("active");                          
                            $(".artistResidenceHeaderElement").removeClass("invisible");                          
                            if(_artistResidenceCurrentElement){
                                _artistResidenceCurrentElement.removeClass("loading");
                                _artistResidenceCurrentElement.addClass("active");
                                openFlipImage(_artistResidenceCurrentElement.attr("data-img2"));     
                            }
                            $(".preloader").hide();
                        }, 100);                    
                    }
                }                
            }

            var _arTime = 0;
            var _arStep = 10;
            var _arInterval = null;

            function startMovement(){
                if(!_artistResidenceMobileVersionEnabled || $(window).width() > 767){
                    _artistResidenceMovementRunning = true;            
                    
                    _arTime = 0;
                    requestAnimationFrame(movementStep);                

                    //startIntervalAnimation();
                }
            }

			/*
            function startIntervalAnimation(){
                if(_arInterval){
                    clearInterval(_arInterval);
                }
                _arInterval = setInterval(function(){
                    if(_artistResidenceMovementRunning){
    
                        $(".artistResidenceHeaderElement").each(function(){                            
                            var pos = $(this).position().left;
                            
                            if(pos <= 0-$(this).width()){
                                var np1 = _artistResidenceElementsWidth + pos;                            
                                //Drupal.behaviors.functions.consolog("moved element " + $(this).attr("data-number") + " with pos " + pos + " to " + np1);
                                $(this).css("left", np1);
                            }
                            else{
                                $(this).css("left", pos-_arStep);
                            }
                        });
                    }
                }, 40);
            }
			*/
        
            function movementStep(time){

                if(_artistResidenceMovementRunning){

                    var delta = (time-_arTime) / 100;                  
                    if(_arTime <= 0){
                        delta = 0.1;
                    }

                    $(".artistResidenceHeaderElement").each(function(){                            
                        var pos = $(this).position().left;
                        
                        if(pos <= 0-$(this).width()){
                            var np1 = _artistResidenceElementsWidth + pos;             
							
                            $(this).css("left", np1);
                        }
                        else{
                            $(this).css("left", pos - _arStep*delta);
                        }
                    });
                    window.requestAnimationFrame(movementStep);
                }

                _arTime = time;
            }            

            function stopMovement(){                
                _artistResidenceMovementRunning = false;
                //_arTime = 0;
            }

            function openFlipImage(backurl){
                
                _artistResidenceTransformCompleteCount = 0;

                //Drupal.behaviors.functions.consolog("openFlipImage()");

                Drupal.behaviors.artistGallery.handleSliderResize();
                stopMovement();                

                _artistResidenceCurrentElement.addClass("invisible");

                var targetElement = $(".artistGalleryImageSliderPage ").first().children(".artistGalleryImage").children("img");                                            
                //get pos and size values
                var targetX = targetElement.offset().left;
                var targetY = targetElement.offset().top;
                var targetWidth = targetElement.width();
                var targetHeight = targetElement.height();

                $(".artistResidenceHeaderDetail").removeClass("preshow");

                //show flip image
                $(".artistResidenceHeaderFlipImage").show();
                
                //show detail view
                showArtistResidenceDetail(1000);

                //Drupal.behaviors.functions.consolog("openFlipImage() artistResidenceHeaderFlipImage:" + $(".artistResidenceHeaderFlipImage").length);

                //start flip animation (http://ricostacruz.com/jquery.transit/)
                var pp = $(window).width();
                $(".artistResidenceHeaderFlipImage").transition({
                    perspective: pp+'px',
                    width: targetWidth,
                    height: targetHeight,  
                    left: targetX,
                    top: targetY,
                    complete: function() { 
                        //Drupal.behaviors.functions.consolog("openFlipImage() artistResidenceHeaderFlipImage transition COMPLETE");
                        _artistResidenceTransformCompleteCount++;
                    }
                }, 1000, "easeInOutCubic");    
             
                $(".artistResidenceHeaderFlipImage").children(".front").transition({
                    rotateY: "180deg",
                    width: targetWidth,
                    height: targetHeight,                    
                    complete: function() { 
                        //Drupal.behaviors.functions.consolog("openFlipImage() front transition COMPLETE");
                        $(".artistResidenceHeaderFlipImage").hide();     
                        $("body").removeClass("cair-detail-visible");          
                        $("body").addClass("cair-detail-visible");     
                        $(".artistResidenceHeaderDetail").removeClass("flipping");
                        $(".artistResidenceHeaderFlipImage").children(".front").css("transform", "rotateY(180deg)");
                        _artistResidenceTransformCompleteCount++;
                    }
                }, 1000, "easeInOutCubic"); 

                $(".artistResidenceHeaderFlipImage").children(".back").css("opacity", 0);
                $(".artistResidenceHeaderFlipImage").children(".back").transition({
                    opacity: 1,            
                    rotateY: "0deg",
                    width: targetWidth,
                    height: targetHeight,                    
                    complete: function() { 
                        //Drupal.behaviors.functions.consolog("openFlipImage() back transition COMPLETE");
                        $(".artistResidenceHeaderFlipImage").hide();     
                        $("body").removeClass("cair-detail-visible");          
                        $("body").addClass("cair-detail-visible");     
                        $(".artistResidenceHeaderDetail").removeClass("flipping");
                        $(".artistResidenceHeaderFlipImage").children(".back").css("transform", "rotateY(0deg)");
                        _artistResidenceTransformCompleteCount++;
                    }
                }, 1000, "easeInOutCubic");      
                                                            
            }

            function closeFlipImage(){

                _artistResidenceTransformCompleteCount = 0;

                //Drupal.behaviors.functions.consolog("closeFlipImage()");

                $(".artistResidenceHeaderDetail").addClass("flipping");

                $(".artistResidenceHeaderDetail").find(".artistGalleryImage").children("img").attr("src", ""); 
                
                var targetElement = $(".artistResidenceHeaderElement.active");                                              

                if(targetElement.length > 0){
                    var imgContainer = targetElement.children(".artistResidenceHeaderElementImage");
                    var heightOffset = imgContainer.height() - imgContainer.children("img").height();

                    //get pos and size values
                    var targetX = targetElement.offset().left;
                    var targetY = targetElement.offset().top + heightOffset;
                    var targetWidth = targetElement.children(".artistResidenceHeaderElementImage").children("img").width();
                    var targetHeight = targetElement.children(".artistResidenceHeaderElementImage").children("img").height();             
                    $(".artistResidenceHeaderFlipImage").show();  

                    $("body").removeClass("cair-detail-visible");          
                    
                    //start flip animation
                    var pp = $(window).width()*2;
                    $(".artistResidenceHeaderFlipImage").transition({
                        perspective: pp + 'px',
                        width: targetWidth,
                        height: targetHeight,  
                        left: targetX,
                        top: targetY,                         
                        complete: function() { 
                            //Drupal.behaviors.functions.consolog("closeFlipImage() transition COMPLETE");
                            _artistResidenceTransformCompleteCount++;
                            $(".preloader").hide();
                        }
                    }, 1000, "easeInOutCubic"); 
                    $(".artistResidenceHeaderFlipImage").children(".back").transition({
                        opacity: 0,
                        rotateY: "-180deg",
                        width: targetWidth,
                        height: targetHeight,                         
                        complete: function() { 
                            //Drupal.behaviors.functions.consolog("closeFlipImage() back transition COMPLETE");
                            $(".artistResidenceHeaderFlipImage").hide();
                            $(".artistResidenceHeaderElement").removeClass("active");
                            $(".artistResidenceHeaderElement").removeClass("invisible");
                            $(".artistResidenceHeaderDetail").removeClass("flipping");
                            $(".artistResidenceHeaderFlipImage").children(".back").css("transform", "rotateY(-180deg)");
                            _artistResidenceTransformCompleteCount++;
                            $(".preloader").hide();

                            _artistResidenceCurrentElement = null;
                            startMovement();
                        }
                    }, 1000, "easeInOutCubic");
                    $(".artistResidenceHeaderFlipImage").children(".front").transition({
                        rotateY: "0deg",
                        width: targetWidth,
                        height: targetHeight,                         
                        complete: function() { 
                            //Drupal.behaviors.functions.consolog("closeFlipImage() front transition COMPLETE");
                            $(".artistResidenceHeaderFlipImage").children(".front").css("transform", "rotateY(0deg)");
                            _artistResidenceTransformCompleteCount++;
                            $(".preloader").hide();
                        }
                    }, 1000, "easeInOutCubic");
                }
            }

            function showArtistResidenceDetail(animationDuration){
                
                $(".artistResidenceHeaderDetail").removeClass("preshow");
                $(".artistResidenceHeaderDetail").children().css("opacity", 0);  

                //hide link to profile page
                //$(".artistResidenceHeaderDetail").find(".artistGalleryFooterBlock").children(".linkButton").hide();                

                $(".artistResidenceHeaderDetail").fadeIn(animationDuration, function(){
                    
                    $(".artistResidenceHeaderDetail").children().css("opacity", 1);                      

                    $(document).unbind().scroll(function() {
                        if(_artistResidenceTransformCompleteCount == 3){
                            hideArtistResidenceDetail();      
                        }
                    });
                  
                });                  
            }
            function hideArtistResidenceDetail(){

                closeFlipImage(); 

                $(".artistResidenceHeaderDetail").removeClass("preshow");                
                $(".artistResidenceHeaderDetail").children().css("opacity", 0);  
                
                $(".artistResidenceHeaderDetail").fadeOut();  

                $(".preloader").hide();

                //unbind scroll
                $(document).unbind();
            }
        }
    }
    
})(jQuery);
